import { Link } from "react-router-dom";

const footerLinks = [
  { label: "首页", to: "/" },
  { label: "影视分类", to: "/category" },
  { label: "影视资讯", to: "/news" },
  { label: "关于我们", to: "/about" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 border-t border-primary-900/40 bg-primary-950 text-primary-200">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12 md:gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="grid h-9 w-9 place-items-center rounded-md bg-accent-500 text-base font-black text-primary-950">
                姐
              </span>
              <span className="text-lg font-bold text-background-50">姐姐的朋友</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-7 text-primary-300">
              精选影视内容与剧情解析平台。我们不做资源搬运，只认真写清楚一部作品讲了什么、好在哪里。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["深度剧情", "影视资讯", "片单推荐"].map((tag) => (
                <span
                  key={tag}
                  className="rounded-full border border-primary-800 px-3 py-1 text-xs text-primary-300"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-label text-xs tracking-[0.2em] text-primary-400">网站导航</h3>
            <ul className="mt-4 space-y-3 text-sm">
              {footerLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="cursor-pointer text-primary-200 transition-colors hover:text-accent-400">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="font-label text-xs tracking-[0.2em] text-primary-400">内容合作</h3>
            <ul className="mt-4 space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <span className="mt-0.5 flex h-4 w-4 items-center justify-center text-primary-400">
                  <i className="ri-mail-line text-base" />
                </span>
                <a
                  href="mailto:hello@jiejiedepengyou.com"
                  className="cursor-pointer break-all text-primary-200 transition-colors hover:text-accent-400"
                >
                  hello@jiejiedepengyou.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-0.5 flex h-4 w-4 items-center justify-center text-primary-400">
                  <i className="ri-map-pin-line text-base" />
                </span>
                <span className="text-primary-300">上海市徐汇区影视内容产业园 A 座 8 层</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-0.5 flex h-4 w-4 items-center justify-center text-primary-400">
                  <i className="ri-time-line text-base" />
                </span>
                <span className="text-primary-300">工作日 10:00 - 19:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-900/60 pt-6 text-xs text-primary-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2025 姐姐的朋友 · 本站内容为影视介绍与资讯，不提供播放与下载服务。</p>
          <p className="font-label tracking-wide">SISTER&apos;S FRIEND FILM CONTENT STUDIO</p>
        </div>
      </div>
    </footer>
  );
}